import React from 'react'
import { Grid, PageSection as Section } from '@superhi/design'

const ROW_GAP_1 = { small: 24 }
const CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 'full',
  large: 6,
}
const CELL_SPAN_2: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 'full',
  large: 6,
  xlarge: [7, 12],
}

type Props = Pick<
  React.ComponentProps<typeof Section>,
  'id' | 'decorationName' | 'decorationPosition' | 'collapseBottomPadding' | 'noBottomPadding'
> & {
  left: React.ReactElement
  right: React.ReactElement
}

const Intro: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  decorationName,
  decorationPosition,
  collapseBottomPadding,
  noBottomPadding,
  left,
  right,
}) => (
  <Section
    id={id}
    collapseBottomPadding={collapseBottomPadding}
    noBottomPadding={noBottomPadding}
    decorationName={decorationName}
    decorationPosition={decorationPosition}
  >
    <Grid rowGap={ROW_GAP_1}>
      <Grid.Cell span={CELL_SPAN_1}>{left}</Grid.Cell>
      <Grid.Cell span={CELL_SPAN_2}>{right}</Grid.Cell>
    </Grid>
  </Section>
)

export default Intro
